import { render, staticRenderFns } from "./LandingPagesIcon.vue?vue&type=template&id=948c0fe4"
import script from "./LandingPagesIcon.vue?vue&type=script&lang=js"
export * from "./LandingPagesIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports